/* FE — PDP 折叠行按载体显示对应段（artvta，2026-09-23）
 *
 * 为什么需要：折叠行「Matière & finition」「Livraison & retours」里的 custom-liquid 子块
 * 一次输出五个载体的全部段落，每段包在 <div data-fe-carrier="…"> 里；服务端已按
 * selected_or_first_available_variant 预先给不匹配的段加了 hidden。但 Shrine 在前端切换
 * 变体时并不重绘这些 block（同 fe-shipping-checkpoints.js 的情况），所以要在这里补切换。
 *
 * 规则（与 custom-liquid 里的服务端预隐藏一致）：
 *   - 当前变体的 options 拼成一个小写字符串；
 *   - 每个 [data-fe-carrier] 的属性值按已知五个载体词拆开（"cadre noir" 是两个词一个值，
 *     不能简单按空格切）；任一载体词被包含在 options 字符串里就显示，否则加 hidden；
 *   - 整个 product-info 里一个都没匹配上（例如过渡期的「Tableau peint à la main」），全部显示。
 *
 * 变体来源（三路都接，任一路先到都行，重复执行无副作用）：
 *   1. Shrine 的 pubsub：PUB_SUB_EVENTS.variantChange（'variant-change'），带 variant.options，
 *      主选择器与吸底条（secondary-variant-select 继承自 VariantSelects）都会发；
 *   2. document 上 variant-selects / secondary-variant-select 的 change 事件（兜底，写法照抄
 *      fe-shipping-checkpoints.js）；
 *   3. DOMContentLoaded 时按页面上已选中的 option 跑一次。
 *
 * 回滚：删掉本文件，并删掉两个折叠行里的 custom-liquid 子块（或整个折叠行）。
 */
(function () {
  'use strict';

  if (window.__feCarrierToggle) return;
  window.__feCarrierToggle = true;

  var CARRIERS = ['toile', 'cadre noir', 'cadre blanc', 'affiche', 'plexiglas'];

  // 照抄 fe-shipping-checkpoints.js 第 22–31 行：从主选择器读当前选中的 option
  function currentOptions(scope) {
    var vals = [];
    scope.querySelectorAll('variant-selects input:checked').forEach(function (el) {
      vals.push(el.value || '');
    });
    scope.querySelectorAll('variant-selects select').forEach(function (el) {
      vals.push(el.value || '');
    });
    return vals.join(' ').toLowerCase();
  }

  function carriersOf(el) {
    var v = ' ' + (el.getAttribute('data-fe-carrier') || '').toLowerCase().replace(/\s+/g, ' ').trim() + ' ';
    return CARRIERS.filter(function (c) { return v.indexOf(' ' + c + ' ') > -1; });
  }

  function apply(scope, optionsText) {
    var nodes = scope.querySelectorAll('[data-fe-carrier]');
    if (!nodes.length) return;
    var text = (optionsText || '').toLowerCase();
    var hits = [];
    var any = false;
    nodes.forEach(function (el) {
      var hit = carriersOf(el).some(function (c) { return text.indexOf(c) > -1; });
      hits.push(hit);
      if (hit) any = true;
    });
    nodes.forEach(function (el, i) {
      var hide = any && !hits[i];
      if (el.hidden !== hide) el.hidden = hide;
    });
  }

  function scopes() {
    var list = Array.prototype.slice.call(document.querySelectorAll('product-info'));
    return list.length ? list : [document];
  }

  function refreshAll() {
    scopes().forEach(function (scope) { apply(scope, currentOptions(scope)); });
  }

  // 3. 首屏
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }

  // 1. Shrine pubsub（全局 subscribe / PUB_SUB_EVENTS 由主题远程 main.js 声明；不存在就跳过）
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = (event && event.data) || {};
        var variant = data.variant;
        var scope = null;
        if (data.sectionId) {
          scope = document.querySelector('product-info[data-section="' + data.sectionId + '"]');
        }
        setTimeout(function () {
          if (variant && variant.options) {
            var text = variant.options.join(' ');
            (scope ? [scope] : scopes()).forEach(function (s) { apply(s, text); });
          } else {
            refreshAll();
          }
        }, 0);
      });
    }
  } catch (e) {
    /* pubsub 接口变了就只靠下面的 change 监听，不影响页面其它部分 */
  }

  // 2. 照抄 fe-shipping-checkpoints.js 第 54–60 行的监听写法，另加吸底条的 secondary-variant-select
  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var sticky = target.closest('secondary-variant-select, secondary-variant-select-separate');
    if (!sticky && !target.closest('variant-selects')) return;
    var scope = target.closest('product-info') || document;
    // 让 Shrine 自己的变体切换逻辑先跑完
    setTimeout(function () {
      if (sticky && sticky.querySelector('select.variant-dropdown')) {
        // 吸底条 combined 模式：select 的值就是 "option1,option2"
        apply(scope, sticky.querySelector('select.variant-dropdown').value.replace(/,/g, ' '));
      } else if (sticky) {
        var vals = [];
        sticky.querySelectorAll('select').forEach(function (el) { vals.push(el.value || ''); });
        apply(scope, vals.join(' '));
      } else {
        apply(scope, currentOptions(scope));
      }
    }, 0);
  });
})();
